const SHORT_MONTHS = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sept",
  "oct",
  "nov",
  "dec",
];

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const MONTHS_OPTIONS = [
  { entityTitle: "January", value: "jan" },
  { entityTitle: "February", value: "feb" },
  { entityTitle: "March", value: "mar" },
  { entityTitle: "April", value: "apr" },
  { entityTitle: "May", value: "may" },
  { entityTitle: "June", value: "jun" },
  { entityTitle: "July", value: "jul" },
  { entityTitle: "August", value: "aug" },
  { entityTitle: "September", value: "sept" },
  { entityTitle: "October", value: "oct" },
  { entityTitle: "November", value: "nov" },
  { entityTitle: "December", value: "dec" },
];

export const YEARS_OPTIONS = [
  { entityTitle: "2019", value: "2019" },
  { entityTitle: "2020", value: "2020" },
  { entityTitle: "2021", value: "2021" },
  { entityTitle: "2022", value: "2022" },
  { entityTitle: "2023", value: "2023" },
  { entityTitle: "2024", value: "2024" },
  { entityTitle: "2025", value: "2025" },
  { entityTitle: "2026", value: "2026" },
  { entityTitle: "2027", value: "2027" },
  { entityTitle: "2028", value: "2028" },
  { entityTitle: "2029", value: "2029" },
  { entityTitle: "2030", value: "2030" },
];

export const getCurrentMonth = (isShort = false) => {
  const d = new Date();
  return isShort ? SHORT_MONTHS[d.getMonth()] : MONTHS[d.getMonth()];
};
export const getCurrentYear = () => {
  const d = new Date();
  return d.getFullYear();
};

export const convertDateTimeToDate = (date) => {
  const dateObject = new Date(date);
  const day = dateObject.getDate();
  const month = dateObject.getMonth() + 1;
  const year = dateObject.getFullYear();

  return `${day}-${month}-${year}`;
};

export const getPreviousMonth = (isShort = false) => {
  const d = new Date();
  d.setMonth(d.getMonth() - 1);
  return isShort ? SHORT_MONTHS[d.getMonth()] : MONTHS[d.getMonth()];
};

export const getFirstDateOfPreviousMonth = () => {
  const today = new Date();
  const firstDayOfPreviousMonth = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    1
  );
  return firstDayOfPreviousMonth;
};

export const getLastDateOfPreviousMonth = () => {
  const today = new Date();
  const lastDayOfPreviousMonth = new Date(
    today.getFullYear(),
    today.getMonth(),
    0
  );
  return lastDayOfPreviousMonth;
};
